module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$store.state.loaded) ? _c('div', {
    attrs: {
      "id": "university"
    }
  }, [_c('link', {
    attrs: {
      "rel": "stylesheet",
      "property": "stylesheet",
      "href": _vm.stylesheet
    }
  }), _vm._v(" "), (!_vm.$store.getters.isUnmMain) ? _c('header', {
    staticClass: "ds-main",
    class: {
      'ds-background': !_vm.homeRoute,
      'home': _vm.homeRoute
    }
  }, [_c('div', {
    attrs: {
      "id": "header-wraper"
    }
  }, [_c('router-link', {
    staticClass: "header-img",
    attrs: {
      "to": {
        name: 'landing'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.logo
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "menu-items"
    }
  }, [_c('div', {
    staticClass: "menu-trigger menu-item",
    class: {
      focused: _vm.searchFocused
    },
    attrs: {
      "id": "search-menu"
    }
  }, [_c('i', {
    staticClass: "fas fa-search"
  }), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchKey),
      expression: "searchKey"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Search or jump to..."
    },
    domProps: {
      "value": (_vm.searchKey)
    },
    on: {
      "focus": function($event) {
        _vm.searchFocused = true
      },
      "blur": function($event) {
        _vm.searchFocused = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchKey = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "menu-dropdown"
    }
  }, [(_vm.searchFocused) ? _c('ul', {
    staticClass: "menu-dropdown ds-main ds-background"
  }, [(_vm.$route.name !== 'nameSearch') ? _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'nameSearch'
      }
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeNav.apply(null, arguments)
      }
    }
  }, [_vm._v("All Programs")])], 1) : _vm._e(), _vm._v(" "), (_vm.$route.name !== 'interestSearch') ? _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'interestSearch'
      }
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeNav.apply(null, arguments)
      }
    }
  }, [_vm._v("Interest Areas")])], 1) : _vm._e()]) : _vm._e()])], 1), _vm._v(" "), (_vm.showProgramLevelMenu) ? _c('div', {
    staticClass: "menu-trigger menu-item",
    class: {
      selected: _vm.showProgramLevelDropdown
    },
    attrs: {
      "id": "program-level-menu"
    }
  }, [_c('div', {
    staticClass: "menu-button",
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.showProgramLevelDropdown = !_vm.showProgramLevelDropdown
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.selectedProgramLevel) + " "), _c('i', {
    staticClass: "fas fa-chevron-down"
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "menu-dropdown"
    }
  }, [(_vm.showProgramLevelDropdown) ? _c('ul', {
    staticClass: "menu-dropdown ds-main ds-background"
  }, _vm._l((_vm.programLevels), function(level) {
    return _c('li', {
      key: level
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.selectedProgramLevel = level
        }
      }
    }, [_vm._v(_vm._s(level))])])
  }), 0) : _vm._e()])], 1) : _vm._e()])], 1)]) : _c('div', {
    staticClass: "unm-header"
  }, [_c('div', {
    staticClass: "navbar navbar-unm"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('router-link', {
    staticClass: "navbar-brand",
    attrs: {
      "to": {
        name: 'landing'
      }
    }
  }, [_vm._v("\n          The University of New Mexico\n        ")]), _vm._v(" "), _vm._m(0)], 1)]), _vm._v(" "), _c('div', {
    attrs: {
      "aria-label": "department logo block",
      "id": "header",
      "role": "banner"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "menu-trigger menu-item",
    class: {
      focused: _vm.searchFocused
    },
    attrs: {
      "id": "search-menu"
    }
  }, [_c('i', {
    staticClass: "fas fa-search"
  }), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchKey),
      expression: "searchKey"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Search Degrees"
    },
    domProps: {
      "value": (_vm.searchKey)
    },
    on: {
      "focus": function($event) {
        _vm.searchFocused = true
      },
      "blur": function($event) {
        _vm.searchFocused = false
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchKey = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "menu-dropdown"
    }
  }, [(_vm.searchFocused) ? _c('ul', {
    staticClass: "menu-dropdown ds-main ds-background"
  }, [(_vm.$route.name !== 'nameSearch') ? _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'nameSearch'
      }
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeNav.apply(null, arguments)
      }
    }
  }, [_vm._v("All Programs")])], 1) : _vm._e(), _vm._v(" "), (_vm.$route.name !== 'interestSearch') ? _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'interestSearch'
      }
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeNav.apply(null, arguments)
      }
    }
  }, [_vm._v("Interest Areas")])], 1) : _vm._e()]) : _vm._e()])], 1), _vm._v(" "), _vm._m(1)])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "router",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1), _vm._v(" "), _c('div', {
    staticClass: "unm-footer"
  }, [_c('unm-footer')], 1)], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "nav navbar-nav navbar-right hidden-xs",
    attrs: {
      "id": "toolbar-nav"
    }
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "https://directory.unm.edu/departments/",
      "title": "UNM A to Z"
    }
  }, [_vm._v("UNM A-Z")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://my.unm.edu",
      "title": "myUNM"
    }
  }, [_vm._v("myUNM")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://directory.unm.edu",
      "title": "Directory"
    }
  }, [_vm._v("Directory")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "navbar-collapse collapse",
    attrs: {
      "aria-label": "Secondary Navigation",
      "id": "top-nav"
    }
  }, [_c('ul', {
    staticClass: "nav navbar-nav navbar-right",
    attrs: {
      "role": "menubar"
    }
  }, [_c('li', [_c('a', {
    staticClass: "header-link",
    attrs: {
      "href": "https://students.unm.edu/navigating-your-major/index.html"
    }
  }, [_vm._v("Advisement")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "header-link",
    attrs: {
      "href": "https://studenthub.unm.edu"
    }
  }, [_vm._v("Student Hub")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "header-link",
    attrs: {
      "href": "https://catalog.unm.edu"
    }
  }, [_vm._v("Catalog")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "header-link",
    attrs: {
      "href": "https://schedule.unm.edu"
    }
  }, [_vm._v("Course Schedules")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1e51bfd8","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/University.vue
// module id = 1117
// module chunks = 1